import { useDispatch, useSelector } from 'react-redux';
import { useKeycloak } from '@react-keycloak/web';
import { requestlogout, storeStudyPath } from '../actions/AuthActions';

const OIDC_TYPE = 'OpenID Connect';
const BACK_TYPE = 'Backend Login';

export const LoginData = () => {
  const [keycloak, initialized] = useKeycloak();
  const dispatch = useDispatch();
  const authentication = useSelector((state) => state.authentication);

  const getLoginType = () => {
    if (keycloak && initialized) return OIDC_TYPE;
    if (authentication && authentication.isLoggedIn) return BACK_TYPE;
    return null;
  };

  const loginType = getLoginType();

  const getUsername = () => {
    switch (loginType) {
      case OIDC_TYPE:
        return keycloak.idTokenParsed.email;
      case BACK_TYPE:
        return authentication.user;
      case null:
      default:
        return null;
    }
  };

  const logout = () => {
    switch (loginType) {
      case OIDC_TYPE:
        keycloak.logout();
        break;
      case BACK_TYPE:
        dispatch(requestlogout());
        dispatch(storeStudyPath('/'));
        localStorage.removeItem('user');
        window.location.href = '/';
        break;
      default:
    }
  };

  return {
    authenticated: loginType !== null,
    username: getUsername(),
    logout,
  };
};
